import { MaterialModule } from './material-module';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/header/header.component';
import { NavBarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HomeComponent } from './home/home.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ErrorComponent } from './error/error.component';
import { SharedService } from './services/shared.service';
import { HomeService } from './services/home.service';
import { QRCodeModule } from 'angularx-qrcode';
import { AppRoutingModule } from './app-routing.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AuthComponent } from './auth/auth.component';
import { AuthService } from './services/auth.service';
import { NewsComponent } from './shared/news/news.component';
import { QrCodeComponent } from './shared/qr-code/qr-code.component';
import { DatetimeFormatPipe } from './shared/date.pipe';
import { VideoplayerComponent } from './shared/videoplayer/videoplayer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PlaylistComponent } from './shared/playlist/playlist.component';
import { BackgroundComponent } from './shared/background/background.component';
import { SafePipe } from './shared/safe.pipe';
import { QrCodeVideoComponent } from './shared/qr-code-video/qr-code-video.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { UpdateService } from './services/update.service';
import { NewlineToBrPipe } from './shared/newline-to-br.pipe';
import { Piwiktrack } from './shared/piwiktrack';
import { NgOptimizedImage } from '@angular/common';
import { LocalComponent } from './local/local.component';
import { BackgroundLocalComponent } from './shared/background-local/background-local.component';
import { FallbackImgDirective } from './shared/FallbackImgDirective';
import { AnimationComponent } from './local/animation/animation.component';
import { SafetyAnimationComponent } from './local/safety-animation/safety-animation.component';
import { BigHomeComponent } from './big-home/big-home.component';
import { ActivityLoggerService } from './services/activityLogger.service';
import { AutoRefreshService } from './services/auto-refresh.service';
import { BigLocalComponent } from './big-local/big-local.component';
import { CdkAriaLive } from "../../node_modules/@angular/cdk/a11y/index";

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    NavBarComponent,
    FooterComponent,
    ErrorComponent,
    AuthComponent,
    NewsComponent,
    QrCodeComponent,
    DatetimeFormatPipe,
    VideoplayerComponent,
    PlaylistComponent,
    BackgroundComponent,
    SafePipe,
    QrCodeVideoComponent,
    NewlineToBrPipe,
    LocalComponent,
    BackgroundLocalComponent,
    FallbackImgDirective,
    AnimationComponent,
    SafetyAnimationComponent,
    BigHomeComponent,
    BigLocalComponent
  ],
  imports: [
    MaterialModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    QRCodeModule,
    NgbModule,
    NgOptimizedImage,
    ReactiveFormsModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    Piwiktrack,
    CdkAriaLive
],
  providers: [
    SharedService,
    HomeService,
    TranslateModule,
    AuthService,
    UpdateService,
    ActivityLoggerService,
    AutoRefreshService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
